const styles = ({ COLORS }) => ({
  link: {
    fontSize: '20px',
    position: 'relative',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    borderLeft: '1px solid #eee',
    '& > a': {
      textDecoration: 'none',
      color: 'rgba(153,153,153,1)',
      transition: 'color 0.3s ease-in-out',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      padding: '0 24px'
    },
    '&:hover > a': {
      color: COLORS.BLUE.NORMAL
    },
    '&:after': {
      left: 0,
      width: '100%',
      height: '4px',
      bottom: 0,
      content: '""',
      position: 'absolute',
      transform: 'scaleX(0)',
      transition: 'transform 0.3s ease-in-out',
      backgroundColor: 'rgba(0,175,236,1)'
    }
  },
  activeLink: {
    '& > a': {
      color: COLORS.BLUE.NORMAL
    },
    '&:after': {
      transform: 'scaleX(1)'
    }
  }
})

export default styles
